<svelte:options customElement="hb-card-video" />

<script lang="ts">
  /**
   * Svelte Card Video WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import dayjs from "dayjs";
  import "dayjs/locale/it";

  import type { Component } from "./types/webcomponent.type";

  let {
    id = "",
    title = undefined,
    description = undefined,
    videosrc = "",
    provider = undefined,
    pageuri = undefined,
    linklabel = "read more",
    time = undefined,

    dateformat = "dddd DD MMMM YYYY HH:mm",
  }: Component = $props();
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap-icons@latest/font/bootstrap-icons.css"
  />
</svelte:head>
<div class="card hb-card-video-root">
  {#if provider === "youtube"}
    <div class="card-image">
      <figure class="image is-16by9">
        <iframe
          class="has-ratio"
          src={videosrc}
          title="YouTube video"
          allowfullscreen
        ></iframe>
      </figure>
    </div>
  {:else}
    <div class="card-image">
      <figure class="image is-16by9 has-background-black">
        <video controls class="has-ratio">
          <source src={videosrc} type="video/mp4" />
          <track kind="captions" src="" srclang="en" label="English" />
          Your browser does not support the video tag.
        </video>
      </figure>
    </div>
  {/if}

  <div class="card-content">
    {#if title}
      <p class="title is-5 mb-2">{title}</p>
    {/if}
    {#if description}
      <div class="content mb-3">
        <p>
          {description.length > 100
            ? description.slice(0, 100)
            : description
              ? description
              : ""}
        </p>
      </div>
    {/if}
    {#if pageuri}
      <div
        class="fb-like"
        data-href={pageuri}
        data-layout="button"
        data-action="like"
        data-size="small"
        data-show-faces="false"
        data-share="false"
      ></div>

      <a
        class="twitter-share-button"
        data-url={pageuri}
        href="https://twitter.com/intent/tweet"
      >
        Tweet</a
      >

      <br />
      {#if linklabel?.length}
        <a href={pageuri} class="button is-primary mt-2">{linklabel}</a>
      {/if}
    {/if}
  </div>
  {#if time}
    <footer class="card-footer">
      <slot name="card-footer">
        <p class="is-size-7 has-text-grey"
          ><i class="bi bi-clock mr-2" aria-hidden="true"></i>{dayjs(time)
            .locale(navigator.language)
            .format(dateformat)
            .replace(/\b\w/g, (l) => l.toUpperCase())}</p
        >
      </slot>
    </footer>
  {/if}
</div>

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
